import type { FetcherSelectorState } from '@peloton/redux-fetch/redux';
import { isDefined } from '@peloton/types/isDefined';
import { pending, isOk, isError } from '@engage/result/pendingResult';
import type { ClassDetail } from './models';
import type { classDetailReducer } from './redux';

export const getNormalizedClassDetail = (
  state: ClassDetailSelectorState,
): ClassDetail | undefined => {
  const detail = state.classDetail.detail;
  return isOk(detail) ? detail.value : undefined;
};

export const getIsClassLoading = (state: ClassDetailSelectorState) =>
  state.classDetail.detail === pending;

export const getIsFriendsLoading = (state: ClassDetailSelectorState) =>
  state.classDetail.friends === pending;

export const isClassDetailError = (state: ClassDetailSelectorState) =>
  isError(state.classDetail.detail);

export const getClassDetail = (
  state: ClassDetailSelectorState,
): ClassDetail | undefined => {
  const detail = getNormalizedClassDetail(state);

  return isDefined(detail) ? detail : undefined;
};

export const getFriendsWhoTookClass = (state: ClassDetailSelectorState) =>
  isOk(state.classDetail.friends) ? state.classDetail.friends.value ?? [] : [];

type ReduxState = { classDetail: ReturnType<typeof classDetailReducer> };
type SelectorState = FetcherSelectorState & ReduxState;
export type ClassDetailSelectorState = SelectorState;
